import React from 'react';

export default function Page(props) {

    const {children} = props;

    const pageStyles = {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    };

    return <main style={pageStyles}>
        {children}
    </main>;
}